import { useEffect, useState } from "react";

import FileUploadButton from "./FileUploadButton";
import { useSelector } from "react-redux";
import DocumentUploaded from "./status/DocumentUploaded";
import DocumentViewed from "./status/DocumentViewed";
import { docsFunctions } from "../../../../../lib/docs";

export default function PracticesUploadItemRecords({practiceId, usedFor, uploadDisabled, caseAttorneyId, uploadPermission, updatePermission, btnRed}) {

    const activeCase = useSelector(state => state.case.activeCase)
    
    const [latestDocument, setLatestDocument] = useState(null)


    useEffect(() => {
        setLatestDocument(docsFunctions.getUploadedDocumentState(activeCase?.procodocs_documents, docsFunctions.returnDocumentTypeID(usedFor)?.id, practiceId, caseAttorneyId))
    }, [activeCase, caseAttorneyId])

    return <>
        {!latestDocument && !uploadDisabled && uploadPermission && <FileUploadButton practiceId={practiceId} activeCase={activeCase} documentTypeId={docsFunctions.returnDocumentTypeID(usedFor)?.id} caseAttorneyId={caseAttorneyId} btnRed={btnRed}/>}
        {latestDocument && <>
            {latestDocument.is_viewed ? <>
                {/* // document is viewd */}
                <DocumentViewed practiceId={practiceId} usedFor={usedFor} documentItem={latestDocument} activeCase={activeCase} uploadDisabled={uploadDisabled} isGeneral={docsFunctions.isDocumentGeneral(latestDocument, practiceId)} isRecords={true} updatePermission={updatePermission}/>               
                
            </> : 
            // document is uploaded but is not viewd 
            <DocumentUploaded practiceId={practiceId} usedFor={usedFor} documentItem={latestDocument} activeCase={activeCase} uploadDisabled={uploadDisabled} isGeneral={docsFunctions.isDocumentGeneral(latestDocument, practiceId)} updatePermission={updatePermission}/>}
        </>}
    </>
}